import React from 'react';
import t from '~t';
import config from '~config';

import { Label, Button, Icon } from '~ui';

export default function ProActions({ subscription: { links = {} } }) {
  return (
    <>
      <Label>{t.s('manage')}</Label>

      <div className='flex flex-wrap justify-self-start [&>:not(:last-child)]:mr-[var(--padding-small)]'>
        {links.manage ? (
          <Button asChild autoFocus>
            <a href={links.manage} target='_blank'>
              <Icon name='user' size='micro' />
              {t.s('changeSubscription')}
            </a>
          </Button>
        ) : null}

        <Button asChild variant='ghost'>
          <a
            href={config.links.pro['help-change-billing-cycle']}
            target='_blank'
          >
            <Icon name='calendar' size='micro' />
            {t.s('changeBillingCycle')}
          </a>
        </Button>

        {links.payments && (
          <Button asChild variant='ghost'>
            <a href={links.payments} target='_blank'>
              <Icon name='document' size='micro' />
              Invoices
            </a>
          </Button>
        )}
      </div>
    </>
  );
}
